import { Injectable } from '@angular/core';
import { IPayerClass } from 'src/app/models/IPayerClass';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PayerClassService {

  constructor(private http: HttpClient) { }

  // Get all payer class details
  getAllPayerClass(): Observable<IPayerClass[]> {
    return this.http.get<IPayerClass[]>(`${configuration.apiUrl + 'Master/PayerClass'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  // Add payer class details
  addPayerClassDetails(payerClassDetails: IPayerClass): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/PayerClass'}`, payerClassDetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Update payer class details
  updatePayerClassDetails(payerClassDetails: IPayerClass): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/PayerClass'}`, payerClassDetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
